var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticStyle:{"font-size":"x-large"}},[_vm._v("溜溜快洗后台管理")]),_c('br'),_c('br'),_c('span',[_vm._v(" 欢迎使用！")])])
}]

export { render, staticRenderFns }